module.exports = __webpack_public_path__ + "img/LayDamCoosa.2a2ce813.jpg";